import * as contentful from "contentful";

export const client = contentful.createClient({
  space: "4i9iov66vv63",
  accessToken: "5We4wi4P_n643ACBelVBhnZldSatJK-z-UEQLFBJU98",
});
